<template>
  <form class="form" @submit.prevent="onSubmit()">
    <FormGroup :label="null" class="mb-1">
      <CheckboxField
        id="mandatory"
        v-model="formValue.Mandatory"
        :disabled="true"
      >
        {{ $t("cookieConsent.mandatory") }}
      </CheckboxField>
    </FormGroup>
    <FormGroup :label="null">
      <CheckboxField
        id="non-essentials"
        v-model="formValue.NonEssentials"
        :disabled="props.disabled"
      >
        {{ $t("cookieConsent.nonEssentials") }}
      </CheckboxField>
    </FormGroup>
    <AppButton type="submit" :loading="props.disabled">
      {{ $t("cookieConsent.agreeWithSelected") }}
    </AppButton>
  </form>
</template>

<script setup lang="ts">
import { reactive } from "vue";
import FormGroup from "@/components/form/form-group.vue";
import AppButton from "@/components/app-button.vue";

import CheckboxField from "@/components/form/checkbox-field.vue";
import { CookieConsent } from "../../types/cookie-consent.enum";

const props = defineProps<{
  disabled?: boolean;
}>();

const emit = defineEmits<{
  (e: "submit", v: CookieConsent[]): void;
}>();

const formValue = reactive<Record<CookieConsent, boolean>>({
  [CookieConsent.Mandatory]: true,
  [CookieConsent.NonEssentials]: true,
});

const onSubmit = () => {
  const selectedConsents = Object.entries(formValue)
    .filter(([_, value]) => value)
    .map(([consent]) => consent as CookieConsent);

  emit("submit", selectedConsents);
};
</script>
